import { render, staticRenderFns } from "./importrecord.vue?vue&type=template&id=a14b890c&scoped=true"
import script from "./importrecord.vue?vue&type=script&lang=ts"
export * from "./importrecord.vue?vue&type=script&lang=ts"
import style0 from "./importrecord.vue?vue&type=style&index=0&id=a14b890c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14b890c",
  null
  
)

export default component.exports